// Datums-Helfer. Alle App-Daten sind LOKALE Kalendertage (YYYY-MM-DD), nie UTC –
// sonst landen Einträge nachts auf dem falschen Tag. Der Container bekommt dafür
// `TZ` gesetzt (docker-compose*.yml), das Frontend schickt sein lokales Datum mit.

export const DAY_MS = 86_400_000;

/** Lokales Kalenderdatum als YYYY-MM-DD („sv-SE" liefert genau dieses Format). */
export function localDate(d: Date = new Date()): string {
  return d.toLocaleDateString('sv-SE');
}

/** Lokales Datum, um `days` verschoben. */
export function localDateOffset(days: number, from: Date = new Date()): string {
  return localDate(new Date(from.getTime() + days * DAY_MS));
}

/** YYYY-MM-DD → Date auf Tagesmitte (vermeidet DST-/UTC-Kantenfälle beim Rechnen). */
export function dateFromIso(iso: string): Date {
  return new Date(`${iso}T12:00:00`);
}

/** Millisekunden-Zeitstempel der Tagesmitte eines YYYY-MM-DD. */
export function dayMs(iso: string): number {
  return dateFromIso(iso).getTime();
}

/** Ganze Tage von `iso` bis heute (negativ = liegt in der Zukunft). */
export function daysSince(iso: string, now: Date = new Date()): number {
  return Math.round((localDateMidnight(now) - dayMs(iso)) / DAY_MS);
}

/** Ganze Tage von heute bis `iso` (negativ = liegt in der Vergangenheit). */
export function daysUntil(iso: string, now: Date = new Date()): number {
  // `- 0` vermeidet -0, das sich in Vergleichen und JSON unschön verhält.
  return -daysSince(iso, now) + 0;
}

function localDateMidnight(now: Date): number {
  return dayMs(localDate(now));
}

/** SQLite-`datetime('now')` (UTC, „YYYY-MM-DD HH:MM:SS") → Date. */
export function parseSqlUtc(value: string): Date {
  return new Date(`${value.replace(' ', 'T')}Z`);
}

/** Aktueller Zeitpunkt im SQLite-Format (UTC). */
export function sqlNow(d: Date = new Date()): string {
  return d.toISOString().slice(0, 19).replace('T', ' ');
}

export const WEEKDAYS_SHORT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'] as const;
export const WEEKDAYS_LONG = [
  'Sonntag',
  'Montag',
  'Dienstag',
  'Mittwoch',
  'Donnerstag',
  'Freitag',
  'Samstag',
] as const;

/** Montag der Woche, in der `d` liegt (deutsche Wochenzählung). */
export function startOfWeek(d: Date = new Date()): Date {
  const copy = new Date(d);
  const day = (copy.getDay() + 6) % 7; // Mo=0 … So=6
  copy.setDate(copy.getDate() - day);
  copy.setHours(12, 0, 0, 0);
  return copy;
}
